import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAccessToken, isTokenExpired } from '@utils/helpers';

export const HomeRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const loungeId = searchParams.get('loungeId');
  const token = getAccessToken();

  useEffect(() => {
    const isAuthenticated = token && !isTokenExpired(token);

    if (!isAuthenticated) {
      navigate(
        loungeId ? `/login/phone?loungeId=${loungeId}` : '/login/phone',
        { replace: true },
      );
    } else if (loungeId) {
      // Always go through card-details first — /booking is only reachable
      // after a successful eligibility check, even for authenticated users.
      navigate(`/card-details/${loungeId}`, { replace: true });
    } else {
      navigate('/select-city', { replace: true });
    }
  }, [navigate, loungeId, token]);

  return null;
};
